/* @flow */

import React from 'react'
import i18n from 'atpjs/helpers/i18n'
import { formatPhone } from 'tve/helpers/phone'

const t = i18n.prefix(['components', 'wrongTimeWrongPlace'])

const WrongTimeWrongPlace = ({ advisor }) => {
  const phoneNumber = advisor.get('phoneNumber')
  return (
    <div className="atp-notification atp-margin-bottom-xs">
      <span className="atp-bold">{t(['title'])}</span>
      <br />
      {t(['text'])}{' '}
      {phoneNumber && (
        <a href={`tel:${phoneNumber}`} className="atp-notification__bold-text">
          {formatPhone(phoneNumber)}
        </a>
      )}
    </div>
  )
}

export default WrongTimeWrongPlace
